import React, { useEffect, useState } from 'react';
import { Platform, Modal, StyleSheet, Dimensions, View } from 'react-native';
import { isTablet } from 'react-native-device-info';
import ModalWeb from 'react-native-modal';
import colors from '../resources/colors';

const GenerateServiceSheetModal = ({ visible, closeModal, children }) => {
  const [height, setHeight] = useState(Dimensions.get('window').height);

  useEffect(() => {
    const listener = Dimensions.addEventListener('change', ({ window }) => {
      setHeight(window.height);
    });

    return () => {
      try {
        listener.remove();
      } catch (error) {
        console.log(error);
      }
    };
  }, []);

  if (Platform.OS === 'web') {
    return (
      <ModalWeb
        isVisible={visible}
        onBackdropPress={() => closeModal()}
        onBackButtonPress={() => closeModal()}
        hasBackdrop={true}
        backdropTransitionInTiming={200}
        backdropTransitionOutTiming={0}
        backdropOpacity={0}
        backdropColor={colors.grey90}
        style={[styles.webModal, {
          width: Dimensions.get('window').width > 624 ? 624 : '100%',
          marginTop: Dimensions.get('window').width > 624 ? 32 : 0,
        }]}>
        <View styles={[styles.webContainer, {
          width: Dimensions.get('window').width > 624 ? 624 : '100%',
        }]}>
          <View style={{ height }}>
            {children}
          </View>
        </View>
      </ModalWeb>
    );
  }

  return (
    <Modal
      animationType="slide"
      transparent={false}
      visible={visible}
      presentationStyle={isTablet() ? 'pageSheet' : 'formSheet'}
      onDismiss={() => closeModal()}
      onRequestClose={() => closeModal()}>
      {children}
    </Modal>
  );
};

const styles = StyleSheet.create({
  webModal: {
    alignItems: undefined,
    justifyContent: undefined,
    height: null,
    overflow: 'hidden',
    borderRadius: 0,
    borderColor: 'rgba(0, 0, 0, 0.1)',
    alignSelf: 'center',
    top: 0,
    margin: 0,
  },
  webContainer: {
    height: '100%',
    backgroundColor: colors.accentWhite,
  },
  webHeight: {
    height: Dimensions.get('window').height,
  },
})

export default GenerateServiceSheetModal;
